const JOB_STATUSES = Object.freeze({
  NEW: 'new',
  REVIEWING: 'reviewing',
  INTERVIEW: 'interview',
  OFFER: 'offer',
  REJECTED: 'rejected',
  HIRED: 'hired',
});

const JOB_STATUS_VALUES = Object.freeze(Object.values(JOB_STATUSES));

const JOB_STATUS_LABELS = Object.freeze({
  [JOB_STATUSES.NEW]: 'New',
  [JOB_STATUSES.REVIEWING]: 'Reviewing',
  [JOB_STATUSES.INTERVIEW]: 'Interview',
  [JOB_STATUSES.OFFER]: 'Offer',
  [JOB_STATUSES.REJECTED]: 'Rejected',
  [JOB_STATUSES.HIRED]: 'Hired',
});

module.exports = {
  JOB_STATUSES,
  JOB_STATUS_VALUES,
  JOB_STATUS_LABELS,
};
